import React, { useEffect } from 'react';
import {
    TextField,
    Box,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    Radio,
    IconButton,
    Divider,
    Card,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
import { useState, createState } from '@hookstate/core';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import Helper from '../../utility/helper';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import CancelIcon from '@mui/icons-material/Cancel';
import dayjs from 'dayjs';

const useStyles = makeStyles({
    dialogContentRoot: {
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});

const tagState = createState({
    tagName: '',
    eventID: 0,
    isDisable: false,
});

const TagDialog = (props) => {
    // console.log("props",props);
    const classes = useStyles();
    const state = useState(tagState);
    const userInfo = useState(null);
    const tagInfo = useState(null);
    const tagStatus = useState(1);
    const allTags = useState(null);
    const formatstartdatehotel = useState('')
    const formatenddatehotel = useState('')
    const formatstartdatePurchasehotel = useState('')
    const formatenddatePurchasehotel = useState('')
    const formatstartdateflight = useState('')
    const formatenddateflight = useState('')
    const tagNameErr = useState('');
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [DateErrorhotel, setErrorhotel] = React.useState('');
    const [DateErrorflight, setErrorflight] = React.useState('');
    const [Tagvaluehotel, setTagvaluehotel] = React.useState('');
    const [TagvaluePurcahsehotel, setTagvaluePurcahsehotel] = React.useState('');
    const [Tagvalueflight, setTagvalueflight] = React.useState('');
    const type = useState(0);
    const hotelPurcahseType = useState(0);
    const hotelCompType = useState(0);
    const [datePickershotel, setDatePickershotel] = React.useState([
        { startDate: '', endDate: '' },
    ]);
    const [datePickersPurcahsehotel, setDatePickersPurcahsehotel] = React.useState([
        { startDate: '', endDate: '' },
    ]);
    const [datePickersflight, setDatePickersflight] = React.useState([
        { startDate: '', endDate: '' },
    ]);

    const [purchase, setPurcahse] = React.useState();

    useEffect(() => {
        state.tagName.set('');
        const guserInfo = Helper.getStorage('userInfo');
        const geventInfo = Helper.getStorage('eventInfo');
        state.eventID.set(geventInfo.eventID);
        userInfo.set(guserInfo);
        if (props.eventTagInfo && tagInfo.get() == null) {
            const eventTagInfo = props.eventTagInfo;
            tagInfo.set(eventTagInfo);
            tagStatus.set(eventTagInfo.status);
            state.tagName.set(eventTagInfo.tagName);
            state.eventID.set(eventTagInfo.eventID);
            // console.log('tagInfo',props.eventTagInfo);
            userInfo.set(guserInfo);
            if (props.eventTagInfo.tagDates && props.eventTagInfo.tagDates.length > 0) {
                let fromDates = []
                let fromPurchaseDates = []
                let toDates = []
                props.eventTagInfo.tagDates.map((dates) => {
                    if (dates.moduleID === 7) {
                        if (dates.isPurchase === 1) {
                            setTagvaluehotel(dates.type == 1 ? "Fixed" : "Range")
                            fromDates.push(
                                { startDate: dates.fromDate, endDate: dates.toDate },
                            )
                        } else if (dates.isPurchase === 2) {
                            setTagvaluePurcahsehotel(dates.type == 1 ? "Fixed" : "Range")
                            fromPurchaseDates.push(
                                { startDate: dates.fromDate, endDate: dates.toDate },
                            )
                        }
                    }
                    if (dates.moduleID === 1) {
                        setTagvalueflight(dates.type == 2 ? "Range" : "Fixed")
                        toDates.push({ startDate: dates.fromDate, endDate: dates.toDate }
                        );
                    }
                })
                // console.log(fromDates, toDates);
                setDatePickershotel(fromDates)
                setDatePickersPurcahsehotel(fromPurchaseDates)
                setDatePickersflight(toDates)
            }
        }

        if (props.allTags) {
            allTags.set(props.allTags);
        }
    }, []);

    function validate(input) {
        let regex = /^[a-zA-Z ]*$/;
        if (regex.test(input.value))
            state.tagName.set(input.replace(/^\s+/, ''));
    }
    const handleAddDatePicker = () => {
        setDatePickershotel([
            ...datePickershotel,
            { startDate: '', endDate: '' },
        ]);
        setDisableBtn(false)
    };
    const handleAddPurchaseDatePicker = () => {
        setDatePickersPurcahsehotel([
            ...datePickersPurcahsehotel,
            { startDate: '', endDate: '' },
        ]);
        setDisableBtn(false)
    };

    const handleRemoveDatePicker = (index) => {
        const updatedDatePickers = [...datePickershotel];
        updatedDatePickers.splice(index, 1);
        setDatePickershotel(updatedDatePickers);
        setDisableBtn(false)
    };
    const handleRemovePurchaseDatePicker = (index) => {
        const updatedDatePickers = [...datePickersPurcahsehotel];
        updatedDatePickers.splice(index, 1);
        setDatePickersPurcahsehotel(updatedDatePickers);
        setDisableBtn(false)
    };
    const handleDatePickerChange = (index, field, date) => {
        const updatedDatePickers = [...datePickershotel];
        updatedDatePickers[index][field] = date;
        setDatePickershotel(updatedDatePickers);
        setDisableBtn(false)
    };
    const handleDatePickerPurchaseChange = (index, field, date) => {
        const updatedDatePurchasePickers = [...datePickersPurcahsehotel];
        updatedDatePurchasePickers[index][field] = date;
        setDatePickersPurcahsehotel(updatedDatePurchasePickers);
        setDisableBtn(false)
    };
    const handleAddDatePickerflight = () => {
        setDatePickersflight([
            ...datePickersflight,
            { startDate: '', endDate: '' },
        ]);
        setDisableBtn(false)
    };

    const handleRemoveDatePickerflight = (index) => {
        const updatedDatePickers = [...datePickersflight];
        updatedDatePickers.splice(index, 1);
        setDatePickersflight(updatedDatePickers);
        setDisableBtn(false)
    };
    const handleDatePickerChangeflight = (index, field, date) => {
        const updatedDatePickers = [...datePickersflight];
        updatedDatePickers[index][field] = date;
        setDatePickersflight(updatedDatePickers);
        setDisableBtn(false)
    };

    const renderDialogContent = () => (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                width: '100%',
            }}>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '10px',
                }}>
                <TextField
                    required
                    autoComplete="off"
                    sx={{ width: '100%' }}
                    size="small"
                    id="outlined-required"
                    label="Tag Name"
                    inputProps={{ maxLength: 20 }}
                    value={state.tagName.get()}
                    onChange={(event) => {
                        //state.tagName.set(event.target.value)
                        validate(event.target.value);
                        { state.tagName.get() ? setDisableBtn(false) : setDisableBtn(true) }
                        handleDisableBtn();
                    }}
                    error={tagNameErr.get().length > 0 ? true : false}
                    helperText={tagNameErr.get()}
                />
            </Box>
            <Card sx={{ p: 2 }}>
                <InputLabel>Hotel Request</InputLabel>
                <Card sx={{ p: 2, mb: 2 }}>
                    <Box><InputLabel>Complimentary</InputLabel></Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                        <RadioGroup
                            row
                            aria-label="hotelType"
                            name="hotelType"
                            value={Tagvaluehotel}
                            onChange={(event) => {
                                setPurcahse(2)
                                setDatePickershotel([{ startDate: '', endDate: '' }])
                                setDisableBtn(false)
                                setTagvaluehotel(event.target.value);
                            }}
                            sx={{
                                '& .MuiSvgIcon-root': {
                                    width: '20px',
                                    height: '20px',
                                },
                            }}>
                            <FormControlLabel
                                value="Fixed"
                                control={<Radio />}
                                label="Fixed"
                            />
                            <FormControlLabel
                                value="Range"
                                control={<Radio />}
                                label="Range"
                            />
                        </RadioGroup>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column' },
                            marginTop: '10px',
                            marginBottom: '10px',
                        }}>
                        {datePickershotel.map((datePicker, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3,1fr)',
                                    gridGap: '20px',
                                    justifyContent: 'center',
                                    margin: '0px 0px 10px 0px'
                                }}>
                                <Box>
                                    <MUIDatePicker
                                        label="Start Date"
                                        value={datePicker.startDate}
                                        error={DateErrorhotel}
                                        setValue={(date) => {
                                            setPurcahse(2)
                                            handleDatePickerChange(
                                                index,
                                                'startDate',
                                                date
                                            )
                                        }
                                        }
                                        disablePast={true}
                                    />
                                </Box>
                                <Box>
                                    <MUIDatePicker
                                        label="End Date"
                                        value={datePicker.endDate}
                                        error={DateErrorhotel}
                                        setValue={(date) => {
                                            setPurcahse(2)
                                            handleDatePickerChange(
                                                index,
                                                'endDate',
                                                date
                                            )
                                        }
                                        }
                                        disablePast={true}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        paddingTop: '6px'
                                    }}
                                >
                                    {index !== 0 && (
                                        <CancelIcon
                                            sx={{ color: 'red' }}
                                            onClick={() =>
                                                handleRemoveDatePicker(index)
                                            }
                                        />
                                    )}
                                    {Tagvaluehotel === 'Fixed'
                                        ? index === 0 && (
                                            <AddCircleRoundedIcon
                                                sx={{ color: '#008000' }}
                                                onClick={handleAddDatePicker}
                                            />
                                        )
                                        : null}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Card>
                <Card sx={{ p: 2 }}>
                    <Box><InputLabel>Purchase</InputLabel></Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                        <RadioGroup
                            row
                            aria-label="hotelType"
                            name="hotelType"
                            value={TagvaluePurcahsehotel}
                            onChange={(event) => {
                                setPurcahse(1)
                                setDatePickersPurcahsehotel([{ startDate: '', endDate: '' }])
                                setDisableBtn(false)
                                setTagvaluePurcahsehotel(event.target.value);
                            }}
                            sx={{
                                '& .MuiSvgIcon-root': {
                                    width: '20px',
                                    height: '20px',
                                },
                            }}>
                            <FormControlLabel
                                value="Fixed"
                                control={<Radio />}
                                label="Fixed"
                            />
                            <FormControlLabel
                                value="Range"
                                control={<Radio />}
                                label="Range"
                            />
                        </RadioGroup>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column' },
                            marginTop: '10px',
                            marginBottom: '10px',
                        }}>
                        {datePickersPurcahsehotel.map((datePicker, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3,1fr)',
                                    gridGap: '20px',
                                    justifyContent: 'center',
                                    margin: '0px 0px 10px 0px'
                                }}>
                                <Box>
                                    <MUIDatePicker
                                        label="Start Date"
                                        value={datePicker.startDate}
                                        error={DateErrorhotel}
                                        setValue={(date) => {
                                            setPurcahse(1)
                                            handleDatePickerPurchaseChange(
                                                index,
                                                'startDate',
                                                date
                                            )
                                        }
                                        }
                                        disablePast={true}
                                    />
                                </Box>
                                <Box>
                                    <MUIDatePicker
                                        label="End Date"
                                        value={datePicker.endDate}
                                        error={DateErrorhotel}
                                        setValue={(date) => {
                                            setPurcahse(1)
                                            handleDatePickerPurchaseChange(
                                                index,
                                                'endDate',
                                                date
                                            )
                                        }
                                        }
                                        disablePast={true}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        paddingTop: '6px'
                                    }}
                                >
                                    {index !== 0 && (
                                        <CancelIcon
                                            sx={{ color: 'red' }}
                                            onClick={() =>
                                                handleRemovePurchaseDatePicker(index)
                                            }
                                        />
                                    )}
                                    {TagvaluePurcahsehotel === 'Fixed'
                                        ? index === 0 && (
                                            <AddCircleRoundedIcon
                                                sx={{ color: '#008000' }}
                                                onClick={handleAddPurchaseDatePicker}
                                            />
                                        )
                                        : null}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Card>
            </Card>
            <Divider orientation="horizontal" flexItem />
            <Card sx={{ p: 2, mt:1 }}>
                <InputLabel>Flight Request</InputLabel>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    <RadioGroup
                        row
                        aria-label="flightType"
                        name="flightType"
                        value={Tagvalueflight}
                        onChange={(event) => {
                            setPurcahse(0)
                            setDatePickersflight([{ startDate: '', endDate: '' }]);
                            setDisableBtn(false)
                            setTagvalueflight(event.target.value);
                        }}
                        sx={{
                            '& .MuiSvgIcon-root': {
                                width: '20px',
                                height: '20px',
                            },
                        }}>
                        <FormControlLabel
                            value="Fixed"
                            control={<Radio />}
                            label="Fixed"
                        />
                        <FormControlLabel
                            value="Range"
                            control={<Radio />}
                            label="Range"
                        />
                    </RadioGroup>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column' },
                        marginTop: '10px',
                    }}>
                    {datePickersflight.map((datePicker, index) => (
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3,1fr)',
                                gridGap: '20px',
                                justifyContent: 'center',
                                margin: '0px 0px 10px 0px'
                            }}>
                            <Box>
                                <MUIDatePicker
                                    label="Start Date"
                                    value={datePicker.startDate}
                                    error={DateErrorflight}
                                    setValue={(date) => {
                                        setPurcahse(0)
                                        handleDatePickerChangeflight(
                                            index,
                                            'startDate',
                                            date
                                        )
                                    }
                                    }
                                    disablePast={true}
                                />
                            </Box>
                            <Box>
                                <MUIDatePicker
                                    label="End Date"
                                    value={datePicker.endDate}
                                    error={DateErrorflight}
                                    setValue={(date) => {
                                        setPurcahse(0)
                                        handleDatePickerChangeflight(
                                            index,
                                            'endDate',
                                            date
                                        )
                                    }
                                    }
                                    disablePast={true}
                                />
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    paddingTop: '6px'
                                }}
                            >
                                {index !== 0 && (
                                    <CancelIcon
                                        sx={{ color: 'red' }}
                                        onClick={() =>
                                            handleRemoveDatePickerflight(index)
                                        }
                                    />
                                )}
                                {Tagvalueflight === 'Fixed'
                                    ? index === 0 && (
                                        <AddCircleRoundedIcon
                                            sx={{ color: '#008000' }}
                                            onClick={handleAddDatePickerflight}
                                        />
                                    )
                                    : null}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Card>
            {tagInfo.get() ? (
                <Box sx={{ mt: 2, mb: 1 }}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                            Status
                        </InputLabel>
                        <Select
                            size="small"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={tagStatus.get()}
                            label="Status"
                            onChange={(event) => {
                                tagStatus.set(event.target.value);
                                handleDisableBtn();
                            }}>
                            <MenuItem value={1}>Active</MenuItem>
                            <MenuItem value={0}>Inactive</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            ) : null}
        </Box>
    );

    const renderDialogActions = () => (
        <ButtonContainer
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText={tagInfo.get() ? 'Update' : 'Create'}
            disableButton={state.isDisable.get()}
            disableUpdateButton={disableBtn}
        />
    );
    const handleDisableBtn = () => {
        if (props.eventTagInfo) {
            let data = props.eventTagInfo;
            let prevData = {
                tagName: data.tagName,
                status: data.status,
            };

            let currentData = {
                tagName: state.tagName.get(),
                status: tagStatus.get(),
            };
            console.log(
                JSON.stringify(prevData) === JSON.stringify(currentData)
            );
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true);
            } else {
                setDisableBtn(false);
            }
        }
    };
    const handleClick = () => {
        if (Tagvaluehotel === 'Fixed') {
            hotelCompType.set(1);
        } else if (Tagvaluehotel === 'Range') {
            hotelCompType.set(2);
        }
        if (TagvaluePurcahsehotel === 'Fixed') {
            hotelPurcahseType.set(1);
        } else if (TagvaluePurcahsehotel === 'Range') {
            hotelPurcahseType.set(2);
        }
        if (Tagvalueflight === 'Fixed') {
            type.set(1);
        } else if (Tagvalueflight === 'Range') {
            type.set(2);
        }
        let isErrorhotel = false;
        let isErrorflight = false;
        let tagtypehotelerror = false;
        let tagtypeflighterror = false;
        // console.log(type.get());
        const tagDatesDataHotel = datePickershotel.map((datePicker) => ({
            tagID: tagInfo.get() ? tagInfo.get().tagID : 0,
            Type: hotelCompType.get(),
            EventID: state.eventID.get(),
            ModuleID: 7,
            isPurchase: 1,
            FromDate: dayjs(datePicker.startDate).format('YYYY-MM-DDTHH:mm'),
            ToDate: dayjs(datePicker.endDate).format('YYYY-MM-DDTHH:mm'),
        }));

        const tagDatesDataPurchaseHotel = datePickersPurcahsehotel.map((datePicker) => ({
            tagID: tagInfo.get() ? tagInfo.get().tagID : 0,
            Type: hotelPurcahseType.get(),
            EventID: state.eventID.get(),
            ModuleID: 7,
            isPurchase: 2,
            FromDate: dayjs(datePicker.startDate).format('YYYY-MM-DDTHH:mm'),
            ToDate: dayjs(datePicker.endDate).format('YYYY-MM-DDTHH:mm'),
        }));

        const tagDatesDataFlight = datePickersflight.map((datePicker) => ({
            tagID: tagInfo.get() ? tagInfo.get().tagID : 0,
            Type: type.get(),
            EventID: state.eventID.get(),
            ModuleID: 1,
            isPurchase: 0,
            FromDate: dayjs(datePicker.startDate).format('YYYY-MM-DDTHH:mm'),
            ToDate: dayjs(datePicker.endDate).format('YYYY-MM-DDTHH:mm'),
        }));
        // console.log("tagDatesDataPurchaseHotel",tagDatesDataPurchaseHotel,"tagDatesDataFlight",tagDatesDataFlight);
        const tagDatesData = [...tagDatesDataHotel, ...tagDatesDataPurchaseHotel, ...tagDatesDataFlight];
        if (tagDatesDataHotel || tagDatesDataFlight || tagDatesDataPurchaseHotel) {
            tagDatesDataHotel.forEach((datePicker, index) => {
                formatstartdatehotel.set(dayjs(datePicker.FromDate).format(
                    'YYYY-MM-DDTHH:mm'
                ))
                formatenddatehotel.set(dayjs(datePicker.ToDate).format(
                    'YYYY-MM-DDTHH:mm'
                ))
                if (formatstartdatehotel.get() > formatenddatehotel.get()) {
                    isErrorhotel = true;
                }
                if ((formatstartdatehotel.get() !== 'Invalid Date' && formatenddatehotel.get() !== 'Invalid Date') && !Tagvaluehotel) {
                    tagtypehotelerror = true
                }

            });
            tagDatesDataPurchaseHotel.forEach((datePicker, index) => {
                formatstartdatePurchasehotel.set(dayjs(datePicker.FromDate).format(
                    'YYYY-MM-DDTHH:mm'
                ))
                formatenddatePurchasehotel.set(dayjs(datePicker.ToDate).format(
                    'YYYY-MM-DDTHH:mm'
                ))
                if (formatstartdatePurchasehotel.get() > formatenddatePurchasehotel.get()) {
                    isErrorhotel = true;
                }
                if ((formatstartdatePurchasehotel.get() !== 'Invalid Date' && formatenddatePurchasehotel.get() !== 'Invalid Date') && !TagvaluePurcahsehotel) {
                    tagtypehotelerror = true
                }

            });
            tagDatesDataFlight.forEach((datePicker, index) => {
                formatstartdateflight.set(dayjs(datePicker.FromDate).format(
                    'YYYY-MM-DDTHH:mm'
                ))
                formatenddateflight.set(dayjs(datePicker.ToDate).format(
                    'YYYY-MM-DDTHH:mm'
                ))
                if (formatstartdateflight.get() > formatenddateflight.get()) {
                    isErrorflight = true;
                }
                if ((formatstartdateflight.get() !== 'Invalid Date' && formatenddateflight.get() !== 'Invalid Date') && !Tagvalueflight) {
                    tagtypeflighterror = true
                }
            });
        }

        // console.log('tag name',state.tagName.get())
        if (!state.tagName.get() || isErrorhotel || isErrorflight || tagtypehotelerror || tagtypeflighterror) {
            if (!state.tagName.get()) {
                tagNameErr.set('Please enter tag name');
            }
            if (isErrorhotel) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Hotel Request end date should be greater then start date',
                });
                return false;
            }
            if (isErrorflight) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Flight Request end date should be greater then start date',
                });
                return false;
            }
            if (tagtypehotelerror) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Select Hotel Tag Type',
                });
                return false;

            }
            if (tagtypeflighterror) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Select Flight Tag Type',
                });
                return false;

            }
            // props.setSnackBarProps({ ...props.snackBarProps, openSnack: true, variant: 'error', message: 'Please Enter Tag Name' });
        }

        else {
            let requestObj = {};
            let tagObj = {};
            tagObj.tagID = tagInfo.get() ? tagInfo.get().tagID : 0;

            if (allTags.get() && tagObj.tagID >= 0) {
                let findInd = allTags
                    .get()
                    .findIndex(
                        (item) =>
                            item.actualData.tagName == state.tagName.get() &&
                            item.actualData.tagID != tagObj.tagID
                    );
                if (findInd >= 0) {
                    tagNameErr.set('This tag name already exists');
                    // props.setSnackBarProps({ ...props.snackBarProps, openSnack: true, variant: 'error', message: 'This tag name already exists' });
                    return false;
                }
            }

            tagObj.tagName = state.tagName.get();
            tagObj.eventID = state.eventID.get();
            tagObj.status = tagStatus.get();
            tagObj.createdBy = userInfo.get().userID;
            requestObj.tag = tagObj;
            requestObj.TagDates = tagDatesData;

            // console.log("requestObj", requestObj);
            state.isDisable.set(true);
            ApiHelper.post(APIURLConstants.POST_ADD_TAG, requestObj)
                .then((res) => {
                    if (res.data > 0) {
                        if (tagInfo.get()) {
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Tag updated successfully',
                            });
                        } else {
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Tag added successfully',
                            });
                        }
                        // console.log('response received', res)

                        props.handleClose();
                        props.getTagsData();
                    } else {
                        // console.log('res else',res.data)
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Tag already exists',
                        });
                    }
                    state.isDisable.set(false);
                })
                .catch((error) => {
                    state.isDisable.set(false);
                    console.log('Error : ', error);
                    if (error.response && error.response.status === 401) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                    }
                });
        }
    };

    return (
        <>
            <CustomDialog
                title={props.title}
                handleClose={props.handleClose}
                open={props.open}
                fullWidth={true}
                maxWidth={'sm'}
                // title={'Export Itinerary'}
                renderContent={renderDialogContent}
                renderActions={renderDialogActions}
                dialogContentClasses={{ root: classes.dialogContentRoot }}
            />
        </>
    );
};

export default TagDialog;
